export default {
  root: {
    paddingTop: 60,
    boxShadow: '0px 1px 8px rgba(0,0,0,0.1)',
    position: 'relative',
    fontWeight: 'bold',
    paddingBottom: 25,
    '& p': {
      textAlign: 'center',
      color: '#333',
      fontSize: 20,
      margin: 0,
      padding: 0,
      fontWeight: 700
    },
    '& $close': {
      position: 'absolute',
      top: 64,
      right: 17,
      background: 'transparent',
      padding: 0,
      margin: 0,
      cursor: 'pointer',
      border: 0,
      '&:hover': {
        background: 'transparent',
        border: 0,
        '& svg': {
          fill: '#4c4c4c'
        }
      },
      '& svg': {
        fill: '#4c4c4c'
      }
    }
  },
  close: {}
};
